module.exports = "<p ng-repeat=\"doc in $ctrl.data\">\n    <a style=\"float:right; margin-left: 8px\" target=\"_blank\" ng-href=\"/api/storage/{{doc.document}}\"\n       class=\"btn btn-sm btn-more\" analytics-on=\"click\"\n       analytics-value=\"{{doc._id}}\" analytics-label=\"Download\"\n       analytics-category=\"Document Download\" analytics-event=\"{{doc.title}}\">\n        <i class=\"fa fa-arrow-circle-right\"></i> more</a>\n    <b>{{doc.title}}</b><br/><em>{{doc.description}}</em>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/documents-widget/documents-widget.component.html
// module id = 506
// module chunks = 0